import { createAction } from 'typesafe-actions'

export const wsConnected = createAction('WS_CONNECTED')<void>()
